<template>
  <div class="analise-ia-page">
    <section class="page-header">
      <div>
        <p class="kicker">Administração</p>
        <h1>{{ pageTitle }}</h1>
      </div>
      <div class="header-actions">
        <v-btn v-if="!modoValidacao" outlined color="secondary" @click="$router.push({ name: 'analise-evidencias-ia.regras' })">
          Regras
        </v-btn>
        <v-btn outlined color="success" :loading="loadingExportacao" @click="exportarResultados">
          XLSX
        </v-btn>
        <v-btn outlined color="success" :loading="loadingExportacaoPdf" @click="exportarResultadosPdf">
          PDF
        </v-btn>
        <v-btn outlined color="warning" :loading="loadingSincronizacao" :disabled="isOrigemIaColeta || !temDecisoesPendentes" @click="sincronizarDecididas">
          {{ modoValidacao ? "Sincronizar lote" : "Sincronizar decisoes" }}
        </v-btn>
        <v-btn outlined color="primary" :loading="loadingPainel" @click="carregarPainel">
          Atualizar
        </v-btn>
      </div>
    </section>

    <v-row>
      <v-col cols="12" md="2" v-for="card in cards" :key="card.label">
        <v-card outlined class="metric-card">
          <v-card-text>
            <div class="text-overline">{{ card.label }}</div>
            <div class="text-h5">{{ card.value }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-alert
      v-if="!modoValidacao"
      class="mb-4"
      :type="runtime.openAiApiKeyConfigurada ? 'success' : 'warning'"
      outlined
      dense
    >
      Avaliacao automatica: {{ runtime.openAiApiKeyConfigurada ? "configurada" : "indisponivel" }}
    </v-alert>

    <v-card v-if="!modoValidacao" outlined class="mb-4">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">
            <v-select v-model="filtro.tipoBase" :items="tiposBase" label="Base" outlined dense />
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              v-model="filtro.origemEvidencia"
              :items="origensEvidencias"
              item-text="text"
              item-value="value"
              label="Origem"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field v-model.number="filtro.ciclo" label="Ciclo" type="number" outlined dense />
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="filtro.uf" :items="ufs" label="UF" outlined dense clearable />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="filtro.municipiosIds"
              :items="municipiosFiltrados"
              item-text="nome"
              item-value="id"
              label="Municípios"
              multiple
              chips
              small-chips
              outlined
              dense
              clearable
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleSomenteElegiveisIan">
                  <v-list-item-action>
                    <v-checkbox :input-value="filtro.somenteElegiveisIan" color="primary" readonly hide-details />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Somente elegiveis IAN</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item ripple @click="toggleTodosMunicipios">
                  <v-list-item-action>
                    <v-checkbox :input-value="todosMunicipiosSelecionados()" color="primary" readonly hide-details />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Selecionar todos</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2" />
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="filtro.codigosQuesitos"
              :items="quesitos"
              item-text="label"
              item-value="codigoQuesito"
              label="Quesitos"
              multiple
              chips
              small-chips
              outlined
              dense
              clearable
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleTodosQuesitos">
                  <v-list-item-action>
                    <v-checkbox :input-value="todosQuesitosSelecionados()" color="primary" readonly hide-details />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Selecionar todos</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2" />
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" md="3">
            <v-checkbox v-model="filtro.incluirAprovadas" label="Incluir aprovadas" hide-details class="mt-0" />
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox v-model="filtro.incluirRejeitadas" :label="isOrigemIaColeta ? 'Incluir NAO/REVIEW' : 'Incluir rejeitadas'" hide-details class="mt-0" />
          </v-col>
          <v-col cols="12" md="6" class="panel-actions">
            <v-btn outlined color="warning" :loading="loadingSincronizacao" :disabled="isOrigemIaColeta || !temDecisoesPendentes" @click="sincronizarDecididas">
              Sincronizar decisoes
            </v-btn>
            <v-btn outlined color="primary" :loading="loadingPreview" @click="preview">
              Preview
            </v-btn>
            <v-btn color="primary" :loading="loadingExecucao" @click="criarExecucao">
              Criar execução
            </v-btn>
          </v-col>
        </v-row>
        <v-alert v-if="previewInfo" type="info" outlined class="mt-4">
          {{ previewInfo.totalMunicipios }} municípios, {{ previewInfo.totalQuesitos }} quesitos, {{ previewInfo.totalEvidencias }} evidências.
          <div v-for="aviso in previewInfo.avisos" :key="aviso">{{ aviso }}</div>
        </v-alert>
      </v-card-text>
    </v-card>

    <v-card outlined class="mb-4">
      <v-tabs v-if="!modoValidacao" v-model="tab" background-color="transparent" color="primary">
        <v-tab>Execuções</v-tab>
        <v-tab>Resultados</v-tab>
      </v-tabs>
      <v-divider />
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-data-table
            :headers="headersExecucoes"
            :items="painel.execucoes"
            :loading="loadingPainel"
            class="elevation-0"
            :items-per-page="10"
            no-data-text="Nenhuma execução encontrada."
          >
            <template v-slot:item.criadoEm="{ item }">{{ formatDate(item.criadoEm) }}</template>
            <template v-slot:item.status="{ item }">
              <v-chip small dark :color="statusColor(item.status)">{{ item.status }}</v-chip>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :headers="headersResultados"
            :items="painel.resultados"
            :loading="loadingPainel"
            class="elevation-0 results-table"
            :items-per-page="15"
            no-data-text="Nenhum resultado encontrado."
          >
            <template v-slot:item.origemEvidencia="{ item }">
              <v-chip x-small outlined>{{ sourceLabel(item.origemEvidencia) }}</v-chip>
            </template>
            <template v-slot:item.nomeArquivo="{ item }">
              <button
                type="button"
                class="evidence-file-link"
                :disabled="!canDownloadEvidence(item) || downloadingEvidenceId === evidenceDownloadKey(item)"
                :title="item.nomeArquivo || 'Baixar evidência'"
                @click.stop="downloadEvidence(item)"
              >
                <v-icon x-small class="mr-1">mdi-download</v-icon>
                <span>{{ item.nomeArquivo || "Baixar evidência" }}</span>
              </button>
            </template>
            <template v-slot:item.decisaoIa="{ item }">
              <v-chip small dark :color="decisionColor(item.decisaoIa)">{{ item.decisaoIa || "PENDENTE" }}</v-chip>
            </template>
            <template v-slot:item.confiancaIa="{ item }">{{ formatPercent(item.confiancaIa) }}</template>
            <template v-slot:item.pontuacaoIa="{ item }">{{ formatDecimal(item.pontuacaoIa) }}</template>
            <template v-slot:item.justificativaIa="{ item }">
              <div class="line-clamp">{{ item.justificativaIa }}</div>
            </template>
            <template v-slot:item.decisaoHumana="{ item }">
              <span>{{ item.decisaoHumana || "Sem decisao" }}</span>
              <div class="sync-status">Final: {{ item.decisaoFinalHumana || "-" }}</div>
            </template>
            <template v-slot:item.sincronizado="{ item }">
              <v-chip x-small :color="item.sincronizado ? 'green' : 'grey'" dark>{{ item.sincronizado ? "SIM" : "NAO" }}</v-chip>
            </template>
            <template v-slot:item.acoes="{ item }">
              <v-btn icon small title="Detalhes" @click="abrirDetalhe(item)">
                <v-icon small color="blue-grey">mdi-information-outline</v-icon>
              </v-btn>
              <v-btn icon small title="Aceitar" @click="abrirDecisao(item, 'ACEITAR')">
                <v-icon small color="green">mdi-check</v-icon>
              </v-btn>
              <v-btn icon small title="Rejeitar" @click="abrirDecisao(item, 'REJEITAR')">
                <v-icon small color="red">mdi-close</v-icon>
              </v-btn>
              <v-btn icon small title="Alterar" @click="abrirDecisao(item, 'ALTERAR')">
                <v-icon small color="primary">mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small title="Sincronizar decisao" :disabled="isItemIaColeta(item) || item.sincronizado || !podeSincronizarItem(item)" @click="sincronizarItem(item)">
                <v-icon small color="orange">mdi-sync</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-dialog v-model="dialogDecisao" max-width="680">
      <v-card>
        <v-card-title>Decisão humana</v-card-title>
        <v-card-text>
          <v-select v-model="decisaoForm.decisaoHumana" :items="decisoesHumanas" label="Decisao" outlined dense />
          <v-select
            v-model="decisaoForm.decisaoFinal"
            :items="decisoesFinais"
            label="Decisao final da evidencia"
            outlined
            dense
            hint="Use APROVAR ou REJEITAR para sincronizar com a area final de evidencias."
            persistent-hint
          />
          <v-textarea v-model="decisaoForm.justificativaHumana" label="Justificativa" outlined rows="4" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDecisao = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="savingDecisao" @click="salvarDecisao">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDetalhe" max-width="860">
      <v-card>
        <v-card-title>Detalhes da analise</v-card-title>
        <v-card-text v-if="itemDetalhe">
          <div class="detail-grid">
            <div><strong>{{ primeiraColunaLabel }}</strong><span>{{ itemDetalhe.municipio }}</span></div>
            <div><strong>Quesito</strong><span>{{ itemDetalhe.codigoQuesito }}</span></div>
            <div><strong>Decisao IA</strong><span>{{ itemDetalhe.decisaoIa || "-" }}</span></div>
            <div><strong>Pontuacao</strong><span>{{ formatDecimal(itemDetalhe.pontuacaoIa) }}</span></div>
          </div>
          <h3>Descricao detalhada</h3>
          <p>{{ itemDetalhe.descricaoDetalhadaIa || "Nao registrada." }}</p>
          <h3>Parecer tecnico</h3>
          <p>{{ itemDetalhe.parecerTecnicoIa || itemDetalhe.justificativaIa || "Nao registrado." }}</p>
          <h3>Fundamento da pontuacao</h3>
          <p>{{ itemDetalhe.fundamentoPontuacaoIa || itemDetalhe.faixaPontuacaoIa || "Nao registrado." }}</p>
          <h3 v-if="isCapacitacao(itemDetalhe)">Capacitacao</h3>
          <div v-if="isCapacitacao(itemDetalhe)" class="detail-grid">
            <div><strong>Atendente</strong><span>{{ itemDetalhe.atendenteCertificadoIa || "-" }}</span></div>
            <div><strong>Horas validas</strong><span>{{ formatDecimal(itemDetalhe.horasValidasIa) }}</span></div>
            <div><strong>Cursos validos</strong><span>{{ formatDecimal(itemDetalhe.cursosValidosIa) }}</span></div>
            <div><strong>Qtd. diagnostico</strong><span>{{ formatDecimal(itemDetalhe.qtdAtendentesDiagnosticoIa) }}</span></div>
          </div>
          <p v-if="isCapacitacao(itemDetalhe)">{{ itemDetalhe.resumoCapacitacaoSalaIa || "Resumo consolidado ainda nao registrado." }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDetalhe = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { atualUfDefinition } from "../../../helpers/utils";
import { analiseEvidenciasIaApi } from "../services/api";

function resolveUfAtual() {
  if (atualUfDefinition && atualUfDefinition.uf) {
    return String(atualUfDefinition.uf).toUpperCase();
  }
  return "RJ";
}

function resolveTipoBaseAtual() {
  const host = (window.location.hostname || "").toLowerCase();
  return host.includes("cidadeempreendedora") ? "cidade" : "selo";
}

function isCodigoQuesitoIan(codigo) {
  const numero = Number(String(codigo || "").replace(",", "."));
  return numero >= 1001 && numero < 1050;
}

export default {
  name: "AnaliseEvidenciasIaPainel",
  props: {
    validacao: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tab: this.validacao ? 1 : 0,
      loadingPainel: false,
      loadingPreview: false,
      loadingExecucao: false,
      loadingExportacao: false,
      loadingExportacaoPdf: false,
      loadingSincronizacao: false,
      savingDecisao: false,
      downloadingEvidenceId: null,
      previewInfo: null,
      filtros: { municipios: [], quesitos: [], ufs: [], tiposBase: [], origensEvidencias: [] },
      runtime: { openAiApiKeyConfigurada: false, modeloBusca: "", modeloValidador: "" },
      painel: { resumo: {}, runtime: {}, execucoes: [], resultados: [] },
      filtro: {
        tipoBase: resolveTipoBaseAtual(),
        ciclo: 2026,
        uf: resolveUfAtual(),
        municipiosIds: [],
        codigosQuesitos: [],
        origemEvidencia: "workflow",
        somenteElegiveisIan: false,
        incluirAprovadas: false,
        incluirRejeitadas: false,
      },
      dialogDecisao: false,
      dialogDetalhe: false,
      itemDecisao: null,
      itemDetalhe: null,
      decisaoForm: { decisaoHumana: "ACEITAR", decisaoFinal: "APROVAR", justificativaHumana: "" },
      decisoesHumanas: ["ACEITAR", "REJEITAR", "ALTERAR"],
      decisoesFinais: ["APROVAR", "REJEITAR", "REVISAO"],
      headersExecucoes: [
        { text: "Execução", value: "codigoExecucao" },
        { text: "Base", value: "tipoBase" },
        { text: "Ciclo", value: "ciclo" },
        { text: "UF", value: "uf" },
        { text: "Status", value: "status" },
        { text: "Evidências", value: "totalEvidencias" },
        { text: "Criado em", value: "criadoEm" },
      ],
      headersResultados: [
        { text: "Município", value: "municipio" },
        { text: "Quesito", value: "codigoQuesito" },
        { text: "Fonte", value: "origemEvidencia" },
        { text: "Arquivo", value: "nomeArquivo" },
        { text: "IA", value: "decisaoIa" },
        { text: "Conf.", value: "confiancaIa" },
        { text: "Pontos", value: "pontuacaoIa" },
        { text: "Justificativa", value: "justificativaIa" },
        { text: "Humano", value: "decisaoHumana" },
        { text: "Sync", value: "sincronizado" },
        { text: "", value: "acoes", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    modoValidacao() {
      return !!this.validacao;
    },
    pageTitle() {
      return this.modoValidacao ? "Análise de Evidências - IA - Validação" : "Análise de Evidências - IA";
    },
    primeiraColunaLabel() {
      return this.filtro.tipoBase === "selo" ? "Sala/Parceiro" : "Município";
    },
    cards() {
      const resumo = this.painel.resumo || {};
      return [
        { label: "Execuções", value: resumo.totalExecucoes || 0 },
        { label: "Evidências", value: resumo.totalEvidencias || 0 },
        { label: "Aprovar IA", value: resumo.aprovadasIa || 0 },
        { label: "Rejeitar IA", value: resumo.rejeitadasIa || 0 },
        { label: "Revisão", value: resumo.revisaoIa || 0 },
        { label: "Decididas", value: resumo.decididasHumano || 0 },
      ];
    },
    tiposBase() {
      return this.filtros.tiposBase && this.filtros.tiposBase.length ? this.filtros.tiposBase : ["selo", "cidade"];
    },
    origensEvidencias() {
      const values = this.filtros.origensEvidencias && this.filtros.origensEvidencias.length
        ? this.filtros.origensEvidencias
        : ["workflow", "ia-coleta"];

      return values.map((value) => ({
        value,
        text: this.sourceLabel(value),
      }));
    },
    isOrigemIaColeta() {
      return this.filtro.origemEvidencia === "ia-coleta";
    },
    ufs() {
      return this.filtros.ufs && this.filtros.ufs.length ? this.filtros.ufs : [resolveUfAtual()];
    },
    municipiosFiltrados() {
      return (this.filtros.municipios || []).filter((m) => {
        const mesmaUf = !this.filtro.uf || m.uf === this.filtro.uf;
        const elegivel = !this.filtro.somenteElegiveisIan || m.elegivelIan;
        return mesmaUf && elegivel;
      });
    },
    quesitos() {
      return (this.filtros.quesitos || [])
        .filter((q) => isCodigoQuesitoIan(q.codigoQuesito))
        .map((q) => ({
          ...q,
          label: `${q.codigoQuesito} - ${q.tema || q.pergunta || ""}`,
        }));
    },
    temDecisoesPendentes() {
      return (this.painel.resultados || []).some((item) => this.podeSincronizarItem(item));
    },
  },
  watch: {
    "filtro.uf"() {
      this.removerSelecoesInvalidas();
      this.previewInfo = null;
    },
    "filtro.somenteElegiveisIan"() {
      this.removerSelecoesInvalidas();
      this.previewInfo = null;
    },
    "filtro.origemEvidencia"() {
      this.previewInfo = null;
    },
  },
  async mounted() {
    await this.carregarRuntime();
    await this.carregarFiltros();
    await this.carregarPainel();
  },
  methods: {
    async carregarRuntime() {
      this.runtime = await analiseEvidenciasIaApi.obterRuntime();
    },
    async carregarFiltros() {
      this.filtros = await analiseEvidenciasIaApi.obterFiltros();
      if (!this.tiposBase.includes(this.filtro.tipoBase)) {
        this.filtro.tipoBase = this.tiposBase[0] || "cidade";
      }
      if (!this.origensEvidencias.some((origem) => origem.value === this.filtro.origemEvidencia)) {
        this.filtro.origemEvidencia = "workflow";
      }
      this.removerSelecoesInvalidas();
    },
    toggleSomenteElegiveisIan() {
      this.filtro.somenteElegiveisIan = !this.filtro.somenteElegiveisIan;
    },
    todosMunicipiosSelecionados() {
      const ids = this.municipiosFiltrados.map((m) => m.id);
      return ids.length > 0 && ids.every((id) => this.filtro.municipiosIds.includes(id));
    },
    toggleTodosMunicipios() {
      const ids = this.municipiosFiltrados.map((m) => m.id);
      if (!ids.length) return;

      if (this.todosMunicipiosSelecionados()) {
        this.filtro.municipiosIds = this.filtro.municipiosIds.filter((id) => !ids.includes(id));
      } else {
        this.filtro.municipiosIds = Array.from(new Set([...(this.filtro.municipiosIds || []), ...ids]));
      }
    },
    todosQuesitosSelecionados() {
      const codigos = this.quesitos.map((q) => q.codigoQuesito);
      return codigos.length > 0 && codigos.every((codigo) => this.filtro.codigosQuesitos.includes(codigo));
    },
    toggleTodosQuesitos() {
      const codigos = this.quesitos.map((q) => q.codigoQuesito);
      if (!codigos.length) return;

      if (this.todosQuesitosSelecionados()) {
        this.filtro.codigosQuesitos = this.filtro.codigosQuesitos.filter((codigo) => !codigos.includes(codigo));
      } else {
        this.filtro.codigosQuesitos = Array.from(new Set([...(this.filtro.codigosQuesitos || []), ...codigos]));
      }
    },
    removerSelecoesInvalidas() {
      const municipiosValidos = new Set(this.municipiosFiltrados.map((m) => m.id));
      const quesitosValidos = new Set(this.quesitos.map((q) => q.codigoQuesito));
      this.filtro.municipiosIds = (this.filtro.municipiosIds || []).filter((id) => municipiosValidos.has(id));
      this.filtro.codigosQuesitos = (this.filtro.codigosQuesitos || []).filter((codigo) => quesitosValidos.has(codigo));
    },
    async carregarPainel() {
      this.loadingPainel = true;
      try {
        this.painel = await analiseEvidenciasIaApi.obterPainel(this.filtro);
        this.runtime = this.painel.runtime || this.runtime;
      } finally {
        this.loadingPainel = false;
      }
    },
    async preview() {
      this.loadingPreview = true;
      try {
        this.previewInfo = await analiseEvidenciasIaApi.preview(this.filtro);
      } finally {
        this.loadingPreview = false;
      }
    },
    async criarExecucao() {
      this.loadingExecucao = true;
      try {
        await analiseEvidenciasIaApi.criarExecucao(this.filtro);
        await this.carregarPainel();
        this.tab = 1;
      } finally {
        this.loadingExecucao = false;
      }
    },
    abrirDetalhe(item) {
      this.itemDetalhe = item;
      this.dialogDetalhe = true;
    },
    abrirDecisao(item, decisao) {
      this.itemDecisao = item;
      this.decisaoForm = {
        decisaoHumana: decisao,
        decisaoFinal: this.resolveDecisaoFinalPadrao(item, decisao),
        justificativaHumana: item.justificativaHumana || item.justificativaIa || "",
      };
      this.dialogDecisao = true;
    },
    async salvarDecisao() {
      if (!this.itemDecisao) return;
      this.savingDecisao = true;
      try {
        await analiseEvidenciasIaApi.registrarDecisao(this.itemDecisao.analiseEvidenciasIaItemId, this.decisaoForm);
        this.dialogDecisao = false;
        await this.carregarPainel();
      } finally {
        this.savingDecisao = false;
      }
    },
    async downloadEvidence(item) {
      if (!this.canDownloadEvidence(item)) {
        this.$notification.error("Evidência sem arquivo vinculado.");
        return;
      }

      const downloadKey = this.evidenceDownloadKey(item);
      this.downloadingEvidenceId = downloadKey;
      try {
        const resp = this.isItemIaColeta(item)
          ? await analiseEvidenciasIaApi.downloadIaArquivo(item.origemReferenciaId)
          : await analiseEvidenciasIaApi.downloadEvidencia(item.perguntaEvidenciaId);
        const contentType = resp.headers["content-type"] || "";

        if (contentType.includes("application/json")) {
          const payload = JSON.parse(await resp.data.text());
          if (payload && payload.url) {
            this.openDownloadUrl(payload.url);
            return;
          }
        }

        const blob = new Blob([resp.data], { type: contentType || "application/octet-stream" });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.target = "_blank";
        link.download = item.nomeArquivo || "evidencia";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        this.$notification.error("Erro ao baixar evidência.");
      } finally {
        this.downloadingEvidenceId = null;
      }
    },
    async exportarResultados() {
      this.loadingExportacao = true;
      try {
        const resp = await analiseEvidenciasIaApi.exportarResultados(this.filtro);
        const blob = new Blob([resp.data], {
          type: resp.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "analise-evidencias-ia.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        this.$notification.error("Erro ao exportar resultados.");
      } finally {
        this.loadingExportacao = false;
      }
    },
    async exportarResultadosPdf() {
      this.loadingExportacaoPdf = true;
      try {
        const resp = await analiseEvidenciasIaApi.exportarResultadosPdf(this.filtro);
        const blob = new Blob([resp.data], {
          type: resp.headers["content-type"] || "application/pdf",
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "analise-evidencias-ia.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        this.$notification.error("Erro ao exportar PDF.");
      } finally {
        this.loadingExportacaoPdf = false;
      }
    },
    async sincronizarItem(item) {
      if (!item || !item.analiseEvidenciasIaItemId) return;
      if (this.isItemIaColeta(item)) {
        this.$notification.error("Itens da coleta IA devem ser inseridos no workflow antes da sincronizacao.");
        return;
      }
      this.loadingSincronizacao = true;
      try {
        const resultado = await analiseEvidenciasIaApi.sincronizarItem(item.analiseEvidenciasIaItemId, this.origemTelaAtual());
        this.notificarSincronizacao(resultado);
        await this.carregarPainel();
      } finally {
        this.loadingSincronizacao = false;
      }
    },
    async sincronizarDecididas() {
      if (this.isOrigemIaColeta) {
        this.$notification.error("Itens da coleta IA devem ser inseridos no workflow antes da sincronizacao.");
        return;
      }
      this.loadingSincronizacao = true;
      try {
        const resultado = await analiseEvidenciasIaApi.sincronizarDecididas({
          ...this.filtro,
          origemTela: this.origemTelaAtual(),
        });
        this.notificarSincronizacao(resultado);
        await this.carregarPainel();
      } finally {
        this.loadingSincronizacao = false;
      }
    },
    notificarSincronizacao(resultado) {
      const total = resultado && resultado.totalSincronizados ? resultado.totalSincronizados : 0;
      if (total > 0) {
        this.$notification.success(`${total} decisao(oes) sincronizada(s).`);
      } else {
        const aviso = resultado && resultado.avisos && resultado.avisos.length ? resultado.avisos[0] : "Nenhuma decisao sincronizada.";
        this.$notification.error(aviso);
      }
    },
    resolveDecisaoFinalPadrao(item, decisaoHumana) {
      if (decisaoHumana === "ACEITAR") {
        return item && item.decisaoIa ? item.decisaoIa : "REVISAO";
      }
      if (decisaoHumana === "REJEITAR") {
        return "REJEITAR";
      }
      return item && item.decisaoFinalHumana ? item.decisaoFinalHumana : "APROVAR";
    },
    podeSincronizarItem(item) {
      if (!item || item.sincronizado) return false;
      if (this.isItemIaColeta(item)) return false;
      return (
        item.decisaoFinalHumana === "APROVAR" ||
        item.decisaoFinalHumana === "REJEITAR" ||
        item.decisaoIa === "APROVAR" ||
        item.decisaoIa === "REJEITAR"
      );
    },
    origemTelaAtual() {
      return this.modoValidacao ? "analise-evidencias-ia-validacao" : "analise-evidencias-ia-painel";
    },
    sourceLabel(value) {
      return value === "ia-coleta" ? "Coleta IA" : "Workflow";
    },
    isItemIaColeta(item) {
      return item && item.origemEvidencia === "ia-coleta";
    },
    evidenceDownloadKey(item) {
      if (!item) return null;
      return this.isItemIaColeta(item)
        ? `ia-${item.origemReferenciaId || ""}`
        : `wf-${item.perguntaEvidenciaId || ""}`;
    },
    canDownloadEvidence(item) {
      if (!item) return false;
      return this.isItemIaColeta(item) ? !!item.origemReferenciaId : !!item.perguntaEvidenciaId;
    },
    openDownloadUrl(url) {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formatDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString("pt-BR");
    },
    formatPercent(value) {
      if (value === null || value === undefined) return "-";
      return `${Math.round(Number(value) * 100)}%`;
    },
    formatDecimal(value) {
      if (value === null || value === undefined || value === "") return "-";
      return Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 2 });
    },
    isCapacitacao(item) {
      return item && (item.codigoQuesito === "5.0" || item.codigoQuesito === "2.3");
    },
    statusColor(status) {
      if (status === "CONCLUIDA_TRIAGEM") return "green";
      if (status === "ERRO") return "red";
      return "blue";
    },
    decisionColor(decision) {
      if (decision === "APROVAR") return "green";
      if (decision === "REJEITAR") return "red";
      if (decision === "REVISAO") return "orange";
      return "grey";
    },
  },
};
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.kicker {
  margin: 0 0 4px;
  font-size: 12px;
  text-transform: uppercase;
  color: #546e7a;
}
.page-header h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
}
.header-actions,
.panel-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.metric-card {
  border-radius: 6px;
}
.line-clamp {
  max-width: 520px;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.results-table {
  font-size: 13px;
}
.evidence-file-link {
  display: inline-flex;
  align-items: flex-start;
  max-width: 280px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1a5dcc;
  font: inherit;
  line-height: 1.35;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
}
.evidence-file-link:disabled {
  color: #78909c;
  cursor: default;
  text-decoration: none;
}
.evidence-file-link span {
  overflow-wrap: anywhere;
}
.sync-status {
  margin-top: 2px;
  font-size: 11px;
  color: #607d8b;
}
.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.detail-grid div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.detail-grid strong {
  font-size: 12px;
  color: #546e7a;
}
@media (max-width: 960px) {
  .page-header,
  .header-actions,
  .panel-actions {
    display: block;
  }
  .header-actions .v-btn,
  .panel-actions .v-btn {
    margin: 4px 4px 0 0;
  }
}
</style>
